import { defineMessages } from 'react-intl';

export default defineMessages({
    breedMessage: {
        id: 'tfpa.propertyDetails.views.messages.breedMessage',
        defaultMessage: 'This is a required field.'
    },
});